import { TooltipProps, Tooltip } from "@mui/material";
import { FunctionComponent } from "react";



export const EllipsisTooltip: FunctionComponent<TooltipProps> = ({
  children,
  ...rest
}) => {

  return (
    <Tooltip placement="bottom" {...rest} >
      {children}
    </Tooltip>
  );
};
